<template lang="pug">
  .module__main
    .module__title Список выводов
    .module-content__container
      .filters__container
        .active-status__container
          .search-block__title Статус
          el-select(v-model="search.status" @change="updateSearchDefaults('status')")
            el-option(key="status-option-all" label="Все" value="all")
            el-option(v-for="(locale, key) in withdrawsLocales" :key="`status-option-${key}`" :label="locale" :value="key")
        .account-name__container
          .search-block__title Аккаунт
          el-select(v-model="search.account_name")
            el-option(key="account-name-option-all" label="Все" value="all")
            el-option(v-for="account in names" :key="`status-option-${account}`" :label="account" :value="account")
        .dates__container
          .search-block__title Время
          .date__container
            el-date-picker(
              v-model="search.dates"
              type="datetimerange"
              range-separator="-"
              start-placeholder="От"
              end-placeholder="До"
              :picker-options="dateOptions"
            )
        .notes__container
          .search-block__title Пометки
          el-select(v-model="search.note" @change="updateSearchDefaults('note')")
            el-option(key="note-option-empty" label="Без пометок" value="")
            el-option(key="note-option-problem" label="Проблемные" value="problem")
            el-option(key="note-option-paid" label="Оплаченные" value="paid")
        .search-details__container
          .search-block__title Детали
          .search__container
            el-select(v-model="search.mode" @change="updateSearchDefaults('mode')")
              el-option(v-for="(mode, key) in modesOptions" :key="`search-mode-${key}`" :label="mode.locale" :value="key")
            el-input(v-model="search.value" :placeholder="modesOptions[search.mode].title")
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="withdraws.list"
            style="width: 100%; font-size: 12px",
          )
            el-table-column(label="ID вывода" width="150")
              template(v-slot:default="scope")
                span {{ scope.row.id }}
                span(v-if="scope.row.added_by") {{ ` (${scope.row.added_by})` }}
            el-table-column(prop="account_name" label="Аккаунт" width="100")
            el-table-column(prop="amount" label="Сумма" width="60")
            el-table-column(prop="status" label="Статус" width="100")
              template(v-slot:default="scope")
                span {{ withdrawsLocales[scope.row.status] || scope.row.status }}
            el-table-column(label="Прямой" width="100")
              template(v-slot:default="scope")
                span.color-success(v-if="scope.row.is_direct") ДА
                span.color-warning(v-else) НЕТ
            el-table-column(label="Панель" width="100")
              template(v-slot:default="scope")
                span.color-success(v-if="scope.row.is_panel") ДА
                span.color-warning(v-else) НЕТ
            el-table-column(prop="account_address" label="Адрес вывода" width="150")
              template(v-slot:default="scope")
                a.small-font(:href="`https://live.blockcypher.com/btc/address/${scope.row.account_address}/`" target="_blank") {{ scope.row.account_address }}
            el-table-column(prop="cleaner_address" label="Промежуточный адрес" width="170")
              template(v-slot:default="scope")
                a.small-font(:href="`https://live.blockcypher.com/btc/address/${scope.row.cleaner_address}/`" target="_blank") {{ scope.row.cleaner_address }}
            el-table-column(prop="handler_txid" label="Транзакция вывода" width="170")
              template(v-slot:default="scope")
                a.small-font(:href="`https://live.blockcypher.com/btc/tx/${scope.row.handler_txid}/`" target="_blank") {{ scope.row.handler_txid }}
            el-table-column(prop="cleaner_txid" label="Промежуточная транзакция" width="170")
              template(v-slot:default="scope")
                a.small-font(:href="`https://live.blockcypher.com/btc/tx/${scope.row.cleaner_txid}/`" target="_blank") {{ scope.row.cleaner_txid }}
            el-table-column(prop="createdAt" label="Время создания" width="170")
        .table-pagination__container
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='withdraws.pagination.count',
            :page-size="per_page",
            :current-page='withdraws.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadWithdraws',
          )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_WITHDRAWS_LIST, SWITCH_NOTE } from "../../store/const/withdraws";
import { LOAD_ACCOUNT_PAYINS, LOAD_ACCOUNT_PAYOUTS, LOAD_ACCOUNTS_NAMES } from "../../store/const/accounts";

export default {
  name: 'WithdrawsList',
  data() {
    return {
      page: 1,
      per_page: 50,
      intervalHandle: null,
      search: {
        status: localStorage.getItem('withdraws_search_status') || 'all',
        mode: localStorage.getItem('withdraws_search_mode') || 'id',
        note: localStorage.getItem('withdraws_search_note') || '',
        account_name: 'all',
        dates: '',
        value: '',
      },
      modesOptions: {
        id: { locale: 'По ID вывода', title: 'ID вывода' },
        withdraw_wallet: { locale: 'По кошельку вывода', title: 'Кошелек вывода' },
        handler_wallet: { locale: 'По промежуточному кошельку', title: 'Промежуточный кошелек' },
      },
      dateOptions: {
        shortcuts: [{
          text: 'Сегодня',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Сутки',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        },  {
          text: 'Вчера',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Неделя',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Месяц',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3 месяца',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  async mounted() {
    await this.loadNames();
    await this.loadWithdraws();
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('withdraws', [
      'withdraws',
      'withdrawsLocales',
    ]),
    ...mapGetters('accounts', [
      'names',
    ]),
    isLoading() {
      return this.isFirstLoading && this.loading(LOAD_WITHDRAWS_LIST) === 'loading';
    },
    isError() {
      return this.loading(LOAD_WITHDRAWS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_WITHDRAWS_LIST);
    },
    hasPagination() {
      return this.withdraws.pagination.count > this.per_page;
    },
  },
  methods: {
    ...mapActions('withdraws', {
      loadWithdrawsList: LOAD_WITHDRAWS_LIST,
      switchNote: SWITCH_NOTE,
    }),
    ...mapActions('accounts', {
      loadNames: LOAD_ACCOUNTS_NAMES,
    }),
    startInterval() {
      this.intervalHandle = setInterval(() => this.loadWithdraws(this.page), 10000);
    },
    async loadWithdraws(page = 1) {
      if (this.isLoading) {
        return;
      }
      const params = {
        page,
        per_page: this.per_page,
      }
      if (this.search.value) {
        params[this.search.mode] = this.search.value;
      }
      if (this.search.dates && Array.isArray(this.search.dates)) {
        const from = new Date(this.search.dates[0]);
        const to = new Date(this.search.dates[1]);
        params.from = from.getTime();
        params.to = to.getTime();
      }
      if (this.search.note) {
        params.note = this.search.note;
      }
      if (this.search.status !== 'all') {
        params.status = this.search.status;
      }
      if (this.search.account_name !== 'all') {
        params.account_name = this.search.account_name;
      }
      await this.loadWithdrawsList({ params });
      this.page = page;
    },
    async handleOrderNote(withdraw, type) {
      const request = await this.switchNote({ id: withdraw.id, type });
      if (request.success) {
        withdraw.notes[type] = !withdraw.notes[type];
      } else {
        this.$message.error(request.message || 'Неизвестная ошибка');
      }
    },
    updateSearchDefaults(type) {
      localStorage.setItem(`withdraws_search_${type}`, this.search[type]);
    },
  }
};
</script>
<style scoped>
.note-icon {
  cursor: pointer;
  margin: 0 2px;
  font-size: 20px;
  font-weight: bold;
}

.small-font {
  font-size: 10px;
}

.filters__container {
  justify-content: space-between;
  height: auto;
}

.search-block__title {
  font-size: 12px;
  text-align: center;
  margin-bottom: 2px;
}

.search__container {
  display: flex;
}
</style>
